import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { NotifyService } from 'app/notify';
import { UploaderOptions } from './uploader-options.model';
import { ModalUploaderComponent } from './modal-uploader/modal-uploader.component'

@Injectable()
export class UploaderService {

  constructor(
    private notify: NotifyService
  ) { }

  public openModal(options: UploaderOptions): Observable<any> {
    return this.notify.modal<ModalUploaderComponent, any>(ModalUploaderComponent, options);
  }

}



// WEBPACK FOOTER //
// /dist/src/app/uploader/uploader.service.ts